import React from 'react';
import {
  PurchaseOrderStatusMap,
  ShipmentStatusMap,
  InvoiceStatusMap,
  ProductStatusMap,
  ChannelMap,
} from '../../types';

interface StatusBadgeProps {
  type: 'order' | 'shipment' | 'invoice' | 'product' | 'channel';
  value: number | string;
}

const statusClassMap: Record<string, Record<number, string>> = {
  order: {
    0: 'badge-new',
    1: 'badge-confirmed',
    2: 'badge-shipped',
    3: 'badge-delivered',
    4: 'badge-cancelled',
  },
  shipment: {
    0: 'badge-draft',
    1: 'badge-pending',
    2: 'badge-shipped',
    3: 'badge-delivered',
    4: 'badge-cancelled',
  },
  invoice: {
    0: 'badge-draft',
    1: 'badge-pending',
    2: 'badge-confirmed',
    3: 'badge-paid',
    4: 'badge-rejected',
  },
  product: {
    0: 'badge-active',
    1: 'badge-inactive',
    2: 'badge-draft',
  },
  channel: {
    0: 'badge-new',       // Vendor
    1: 'badge-confirmed', // Seller
  },
};

const labelMap: Record<string, Record<number, string>> = {
  order: PurchaseOrderStatusMap,
  shipment: ShipmentStatusMap,
  invoice: InvoiceStatusMap,
  product: ProductStatusMap,
  channel: ChannelMap,
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ type, value }) => {
  const numericValue = typeof value === 'string' ? parseInt(value, 10) : value;
  const className = statusClassMap[type]?.[numericValue] || 'badge-draft';
  const label = labelMap[type]?.[numericValue] || (typeof value === 'string' ? value : `Status ${value}`);

  return <span className={`badge ${className}`}>{label}</span>;
};

export default StatusBadge;
